import React from 'react'
import useSEO from "./useSEO";
const Constructionsandrealestate = () => {
  useSEO({ 
  title: "Constructions and Real Estate | onstruction and Real Estate Services in Hyderabad | Property & Project Solutions",
  description: "Professional construction and real estate services in Hyderabad, offering residential, commercial, and industrial project management, property development, and investment solutions with quality and trust.",
  keywords: "construction services Hyderabad, Constructions and Real Estate, real estate Hyderabad, property development Hyderabad, residential construction Hyderabad, commercial construction Hyderabad, real estate investment Hyderabad, building contractors Hyderabad, property sales Hyderabad, real estate consultancy Hyderabad",
  ogTitle: "Construction and Real Estate in Hyderabad - Quality Projects & Trusted Solutions",
  ogDescription: "Reliable construction and real estate services in Hyderabad, from project management to property sales and investments.",
  ogImage: "img/real-estate.png",
  twitterTitle: "Construction and Real Estate in Hyderabad - Quality Projects & Trusted Solutions",
  twitterDescription: "We deliver excellence in construction and real estate in Hyderabad with trusted project and property solutions.",
  twitterImage: "img/real-estate.png"
});

  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Constructions and Real Estate </h1>
          <p className="mb-4">
            {" "}
            The Constructions and Real Estate sector is the foundation of modern
            infrastructure and urban development. From residential buildings and
            commercial complexes to large-scale infrastructure projects, the
            industry requires a balance of planning, execution, and compliance
            to deliver value-driven results.{" "}
          </p>
          <p className="mb-4">
            {" "}
            We offer end-to-end support and services tailored to the unique
            needs of construction companies, real estate developers, and
            property managers. Our expertise helps streamline operations, manage
            costs, and ensure timely project delivery — all while maintaining
            regulatory compliance.{" "}
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/real-estate.png" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img src="img/real-estate1.png" className="rounded" alt="" />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Project Planning &amp; Management:</b>
                </li>
                <p>
                  {" "}
                  Structured approach to budgeting, scheduling, resource
                  allocation, and workflow optimization.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Construction Accounting &amp; Finance: </b>
                </li>
                <p>
                  {" "}
                  Specialized accounting for project costing, billing,
                  subcontractor payments, and financial reporting.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Real Estate Sales &amp; Marketing: </b>
                </li>
                <p>
                  {" "}
                  Tools and services to manage property listings, client
                  bookings, payment follow-ups, and agreements.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Regulatory Compliance &amp; Legal Support:</b>
                </li>
                <p>
                  {" "}
                  Guidance on RERA, GST, TDS, land use, building codes, and
                  statutory approvals.{" "}
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Property &amp; Asset Management:</b>
                </li>
                <p>
                  {" "}
                  Comprehensive solutions for leasing, maintenance,
                  documentation, and tenant management.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Inventory &amp; Procurement Control: </b>
                </li>
                <p>
                  {" "}
                  Real-time tracking of raw materials, vendor coordination, and
                  stock movement across sites.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default Constructionsandrealestate
